// Shared trigger styling for every filter-bar picker (`RelationshipFilter`,
// `FacetMultiSelectFilter`, and `PresetDateRangeFilter`'s own `className`
// prop) — one icon-led trigger shape so the whole row reads as a single
// control family. Targets antd's internal `.ant-select-selector` node
// directly (the same `[&_...]:` Tailwind-arbitrary-variant technique already
// used elsewhere in this codebase, e.g. the empty-table scrollbar-gutter
// fix) — `!` modifiers because AntD's own generated selector class carries
// more specificity than an unmarked Tailwind utility.
//
// Geometry follows `UI_UX_GUIDELINES.md` §3.2/§3.3 rather than this page's
// own earlier pill look: 36px control height, 6px control radius
// (`rounded-md`), and the guidelines' own `0 1px 1px rgba(0,0,0,.05)`
// trigger shadow. `text-[13px]` (down from antd's 14px default) so a longer
// label like "Project Manager (3)" still fits its trigger without
// truncating, paired with the `w-[190px]` each picker's own `className`
// uses. The arrow/prefix/placeholder rules only normalise sizes and muted
// tones across the row — antd still renders its own default chevron, so
// every picker keeps the identical glyph.
export const FILTER_PILL_CLASS = [
  "[&_.ant-select-selector]:!h-10",
  "[&_.ant-select-selector]:!items-center",
  "[&_.ant-select-selector]:!rounded-lg",
  "[&_.ant-select-selector]:!border-[#E2E8F0]",
  "[&_.ant-select-selector]:!bg-white",
  "[&_.ant-select-selector]:!px-2.5",
  "[&_.ant-select-selector]:!text-[13px]",
  "[&_.ant-select-selector]:!shadow-[0_2px_6px_rgba(15,23,42,0.06)]",
  "hover:[&_.ant-select-selector]:!border-slate-300",
  "[&.ant-select-focused_.ant-select-selector]:!border-primary",
  "[&.ant-select-focused_.ant-select-selector]:!shadow-[0_0_0_3px_rgba(42,125,140,0.14)]",
  "[&_.ant-select-selection-placeholder]:!text-slate-700",
  "[&_.ant-select-selection-item]:!text-slate-800",
  "[&_.ant-select-prefix]:!text-slate-600",
  "[&_.ant-select-prefix_.anticon]:!text-[14px]",
  "[&_.ant-select-arrow]:!text-slate-600",
  "[&_.ant-select-arrow]:!text-[11px]",
  "[&_.ant-select-selector]:!pr-6",
  "[&_.ant-select-arrow]:!right-2",
  "[&_.ant-select-prefix]:!mr-1.5"
].join(" ")

// Every picker shares the toolbar row rather than holding a fixed width: it
// takes an even share of the space, compresses toward `min-w` as the viewport
// narrows, and never grows past `max-w` on a very wide screen. This is what
// keeps all eight pickers and the three action buttons on one line from
// 1712px up without widening the page or scrolling it sideways, and gives
// each one a readable share of a wrapped row below that. The wrapped basis
// is deliberately wide (~196px): it is what stops eight pickers from all
// squeezing onto one truncated line at 1600, so a wrapped row shows whole
// labels rather than "Project Man…".
// `min-w-0` is required or a flex item refuses to shrink below its content.
export const FILTER_WIDTH_CLASS =
  "h-10 min-w-0 flex-1 basis-[196px] min-[1712px]:basis-[150px] min-[1712px]:max-w-[172px]"

// "Active period: all time" is the one genuinely longer label, so it gets a
// slightly wider share of the same row.
export const ACTIVE_PERIOD_WIDTH_CLASS =
  "h-10 min-w-0 flex-1 basis-[210px] min-[1712px]:basis-[172px] min-[1712px]:max-w-[210px]"
